export const firstCharToLowerCase = (value: string): string => value[0]?.toLowerCase() + value?.slice(1);
